<template>
    <br/>
    <div style="padding:5px"  class="row">
      <div class="col-lg-6 col-md-12 mb-3">
          <label for="search" class="mt-1 me-2">Search</label>
          <input id="search" class="form-control" placeholder="User email" v-model="keyword" @input="searchKeyword"/>
      </div>
      <div class="col-lg-6 col-md-12 mb-3">
        <label for="per-page" class="form-label me-2 mt-2">Per page</label>
        <select id="per-page" class="form-control" v-model="perPage" @change="perPageFilter(perPage)">
          <option :value="10">10</option>
          <option :value="20">20</option>
          <option :value="50">50</option>
        </select>
        </div>
    </div>
    <div style="padding:5px" class="row">
      <div class="col-lg-12 col-md-12 mb-3">
        <button @click="filterThisWeek()" type="button" class="btn btn-dark-purple mb-3 me-2">
          This week
        </button>
        <button v-if="dateFrom" @click="clearDateFilter()" type="button" class="btn btn-secondary mb-3 me-2">
          Clear filter
        </button>
        <span v-if="dateFrom" class="mt-2 ms-2">Filter: {{ dateFrom }} - {{ dateTo }}</span>
      </div>
    </div>
  <div class="table-responsive container-fluid d-grid gap-3">
  <table class="table">
    <thead>
    <tr>
      <th scope="col" @click="orderByFilter('id')" style="cursor: pointer;">
        # ID
        <font-awesome-icon v-if="orderBy === 'id' && orderDirection === 'asc'" icon="fa-solid fa-sort-up" style="margin-left: 5px;"/>
        <font-awesome-icon v-else-if="orderBy === 'id' && orderDirection === 'desc'" icon="fa-solid fa-sort-down" style="margin-left: 5px;"/>
      </th>
      <th scope="col" @click="orderByFilter('user_id')" style="cursor: pointer;">
        User ID
        <font-awesome-icon v-if="orderBy === 'user_id' && orderDirection === 'asc'" icon="fa-solid fa-sort-up" style="margin-left: 5px;"/>
        <font-awesome-icon v-else-if="orderBy === 'user_id' && orderDirection === 'desc'" icon="fa-solid fa-sort-down" style="margin-left: 5px;"/>
      </th>
      <th scope="col">User name</th>
      <th scope="col" @click="orderByFilter('email')" style="cursor: pointer;">
        User email
        <font-awesome-icon v-if="orderBy === 'email' && orderDirection === 'asc'" icon="fa-solid fa-sort-up" style="margin-left: 5px;"/>
        <font-awesome-icon v-else-if="orderBy === 'email' && orderDirection === 'desc'" icon="fa-solid fa-sort-down" style="margin-left: 5px;"/>
      </th>
      <th scope="col" @click="orderByFilter('deletion_at')" style="cursor: pointer;">
        Deletion at
        <font-awesome-icon v-if="orderBy === 'deletion_at' && orderDirection === 'asc'" icon="fa-solid fa-sort-up" style="margin-left: 5px;"/>
        <font-awesome-icon v-else-if="orderBy === 'deletion_at' && orderDirection === 'desc'" icon="fa-solid fa-sort-down" style="margin-left: 5px;"/>
      </th>
    </tr>
    </thead>
    <tbody>
    <tr v-if="requests.length > 0" v-for="request in requests">
      <th scope="row">{{request.id}}</th>
      <td>{{request.user_id}}</td>
      <td>{{request.user_name}}</td>
      <td>{{request.user_email}}</td>
      <td>{{request.deletion_at}}</td>
    </tr>
    <tr v-else-if="loading">
      <td colspan="5" class="text-center"><font-awesome-icon icon="fa-solid fa-sync fa-10x" spin/></td>
    </tr>
    <tr v-else>
      <td colspan="5" class="text-center">No requests</td>
    </tr>
    </tbody>
  </table>
    <div class="d-flex justify-content-between" v-if="totalRecords >= 1">
      <div>
        <div class="p-2">
          <p>Total reports: {{ totalRecords }}</p>
        </div>
      </div>
      <div>
        <div class="p-2">
          <nav v-if="totalPages >= 1" aria-label="Page navigation example">
            <ul class="pagination">
              <li class="page-item" :class="{disabled: currentPage - 1 < 1}">
                <a @click="paginate(currentPage - 1)" class="page-link">Previous</a>
              </li>
              <li class="page-item" :class="{active: 1 === currentPage}">
                <a @click="paginate(1)" class="page-link" :class="{'not-clickable': currentPage === 1}">1</a>
              </li>
              <li v-if="currentPage - 2 > 1" class="page-item">
                <a href="#" class="page-link">...</a>
              </li>
              <li class="page-item" v-if="currentPage - 2 > 1">
                <a @click="paginate(currentPage - 2)" class="page-link">{{ currentPage - 2}}</a>
              </li>
              <li class="page-item" v-if="currentPage - 1 > 1">
                <a @click="paginate(currentPage - 1)" class="page-link">{{ currentPage - 1}}</a>
              </li>
              <li class="page-item" v-if="currentPage !== 1"  :class="{active: currentPage}">
                <a @click="paginate(currentPage)" class="page-link" :class="{'not-clickable': currentPage}">{{currentPage }}</a>
              </li>
              <li class="page-item" v-if="currentPage + 1 <= totalPages">
                <a @click="paginate(currentPage + 1)" class="page-link">{{ currentPage + 1}}</a>
              </li>
              <li class="page-item" v-if="currentPage + 2 <= totalPages">
                <a @click="paginate(currentPage + 2)" class="page-link">{{ currentPage + 2}}</a>
              </li>
              <li class="page-item" v-if="currentPage + 2 < totalPages">
                <a href="#" class="page-link">...</a>
              </li>
              <li class="page-item" v-if="currentPage !== totalPages && currentPage + 2 < totalPages" :class="{active: totalPages === currentPage}">
                <a @click="paginate(totalPages)" class="page-link" :class="{'not-clickable': totalPages === currentPage}">{{totalPages }}</a>
              </li>
              <li class="page-item" :class="{disabled: currentPage + 1 > totalPages}">
                <a @click="paginate(currentPage + 1)" class="page-link">Next</a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  </div>
  <!-- </div> -->
  </template>
  
  
  <script>
  import axios from 'axios';
  import _debounce from "lodash/debounce";
  
  export default {
    data() {
      return {
        loading: true,
        requests: [],
        keyword: '',
        currentPage: 1,
        totalPages: 0,
        totalRecords: 0,
        perPage: 20,
        orderBy: 'id',
        orderDirection: 'asc',
        dateFrom: null,
        dateTo: null
      }
    },
    created() {
      this.getRequests(this.keyword, this.currentPage, this.perPage, this.orderBy, this.orderDirection, this.dateFrom, this.dateTo);
    },
    methods: {
      debounceGetRequests: _debounce(function (keyword, page, perPage, orderBy, orderDirection, dateFrom, dateTo) {
        this.loading = true;

        let paramsString = `?page=${page}&per_page=${perPage}&order_by=${orderBy}&order_direction=${orderDirection}`;
        if (keyword) {
          paramsString += `&keyword=${encodeURIComponent(keyword)}`;
        }
        if (dateFrom) {
          paramsString += `&date_from=${dateFrom}`;
        }
        if (dateTo) {
          paramsString += `&date_to=${dateTo}`;
        }

        axios.get(`/admin/user/delete/requests${paramsString}`).then(response => {
            this.requests = response.data.data;
            this.totalPages = response.data.totalPages;
            this.totalRecords = response.data.totalRecords;
            this.loading = false;
        })
            .catch(error => {
              this.loading = false;
              console.log(error);
            });
      }, 500),
      getRequests(keyword, page, perPage, orderBy, orderDirection, dateFrom, dateTo) {
        this.debounceGetRequests(keyword, page, perPage, orderBy, orderDirection, dateFrom, dateTo);
      },
      searchKeyword() {
        this.currentPage = 1;
        this.getRequests(this.keyword, this.currentPage, this.perPage, this.orderBy, this.orderDirection, this.dateFrom, this.dateTo);
      },
      perPageFilter(perPage) {
        this.perPage = perPage;
        this.currentPage = 1;
        this.getRequests(this.keyword, this.currentPage, this.perPage, this.orderBy, this.orderDirection, this.dateFrom, this.dateTo);
      },
      paginate(page) {
        if (page < 1 || page > this.totalPages) return;
        this.currentPage = page;
        this.getRequests(this.keyword, this.currentPage, this.perPage, this.orderBy, this.orderDirection, this.dateFrom, this.dateTo);
      },
      orderByFilter(column) {
        if (this.orderBy === column) {
          this.orderDirection = this.orderDirection === 'asc' ? 'desc' : 'asc';
        } else {
          this.orderDirection = 'asc';
        }

        this.orderBy = column;
        this.currentPage = 1;
        this.getRequests(this.keyword, this.currentPage, this.perPage, this.orderBy, this.orderDirection, this.dateFrom, this.dateTo);
      },
      filterThisWeek() {
        const today = new Date();
        const dayOfWeek = today.getDay();
        const diff = today.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1); // Adjust when day is Sunday
        const monday = new Date(today.getFullYear(), today.getMonth(), diff);
        monday.setHours(0, 0, 0, 0);
        
        const sunday = new Date(monday);
        sunday.setDate(monday.getDate() + 6);
        sunday.setHours(23, 59, 59, 999);
        
        this.dateFrom = this.formatDate(monday);
        this.dateTo = this.formatDate(sunday);
        this.currentPage = 1;
        this.getRequests(this.keyword, this.currentPage, this.perPage, this.orderBy, this.orderDirection, this.dateFrom, this.dateTo);
      },
      clearDateFilter() {
        this.dateFrom = null;
        this.dateTo = null;
        this.currentPage = 1;
        this.getRequests(this.keyword, this.currentPage, this.perPage, this.orderBy, this.orderDirection, this.dateFrom, this.dateTo);
      },
      formatDate(date) {
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        return `${year}-${month}-${day}`;
      }
    }
  }
  </script>